import { Check } from "lucide-react";
import Reveal from "./Reveal";
import { africaServices, africaStats } from "../data";

export default function Africa() {
  return (
    <section id="africa" className="py-24 md:py-32 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <img
            src="/assets/africa-skyline.jpg"
            alt="African city skyline at golden hour"
            loading="lazy"
            className="w-full object-cover aspect-[4/5]"
          />
          <div className="absolute -top-5 -right-5 h-24 w-24 obled-gradient hidden md:block" aria-hidden="true" />
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-accent mb-5">
            Africa Representation
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-white leading-[1.05]">
            Your strategic gateway to African markets.
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-white/80">
            Obled Corporation helps U.S. companies identify opportunities, connect with reliable
            partners, build local visibility, and develop representation across African markets.
          </p>
          <ul className="mt-8 space-y-3">
            {africaServices.map((s) => (
              <li key={s} className="flex items-center gap-3 text-white/90">
                <span className="flex h-6 w-6 items-center justify-center obled-gradient text-white">
                  <Check size={14} aria-hidden="true" />
                </span>
                {s}
              </li>
            ))}
          </ul>
          <div className="mt-10 grid grid-cols-3 gap-4">
            {africaStats.map((s) => (
              <div key={s.label} className="border border-white/15 p-5 text-center">
                <div className="text-2xl font-display font-medium text-accent">{s.value}</div>
                <div className="mt-1 text-xs text-white/70">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
